import { render, staticRenderFns } from "./OriginSection.vue?vue&type=template&id=7ca1c36c&scoped=true&"
import script from "./OriginSection.vue?vue&type=script&lang=js&"
export * from "./OriginSection.vue?vue&type=script&lang=js&"
import style0 from "./OriginSection.vue?vue&type=style&index=0&id=7ca1c36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1c36c",
  null
  
)

export default component.exports